import { render, staticRenderFns } from "./TamanioCrud.vue?vue&type=template&id=5566dcdf&"
import script from "./TamanioCrud.vue?vue&type=script&lang=js&"
export * from "./TamanioCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports